import { W, H, R } from "./props";

export const HOMEWARD_DURATION = 12.5;
const CAPTIONS = [
  [0.8, 4.0, "They climb out of the cave without a word."],
  [4.4, 8.0, "Nobody wants to be the last one in line."],
  [8.4, 11.8, "The cabin lights have never looked so warm."],
];
export const homewardCaption = (tt) => (CAPTIONS.find(([a, b]) => tt >= a && tt <= b) || [])[2] || null;
const GROUND = 146;
const PEOPLE = [["#7f1d1d", "#c9a25a"], ["#2f4a6b", "#1a1210"], ["#5a4430", "#3a2414"], ["#3b3f4a", "#2a1a10"]];

function walker(ctx, x, top, hair, t, i) {
  const step = Math.floor(t / 220 + i) % 2;
  R(ctx, "#1f2430", x + 1 + step, GROUND - 7, 2, 7); R(ctx, "#1f2430", x + 4 - step, GROUND - 7, 2, 7);
  R(ctx, top, x, GROUND - 17, 7, 10); R(ctx, "#d9b48f", x + 1, GROUND - 23, 5, 6); R(ctx, hair, x + 1, GROUND - 24, 5, 2);
}

export function drawHomeward(ctx, tt, now) {
  ["#0a1020", "#0e1628", "#131d33", "#1a2540"].forEach((c, i) => R(ctx, c, 0, i * 30, W, 30));
  for (let s = 0; s < 110; s++) R(ctx, "#0f1a2e", s * 3, 70 + Math.abs(((s * 2.4) % 80) - 40) * 0.8, 3, H);
  for (let x = 6, i = 0; x < W; x += 17 + (i % 3) * 5, i++) if (x < 190 || x > 290) {
    R(ctx, "#05080f", x + 3, GROUND - 8, 2, 8); for (let k = 0; k < 4; k++) R(ctx, "#070c16", x + 4 - (2 + k * 2), GROUND - 30 + k * 5, 4 + k * 4, 6);
    R(ctx, "#c8d6e3", x + 2, GROUND - 30, 4, 1);
  }
  const cx = 232;
  R(ctx, "#1e150d", cx, GROUND - 30, 56, 30); for (let i = 0; i < 8; i++) R(ctx, "#1e150d", cx - 4 + i * 3, GROUND - 30 - i * 3, 64 - i * 6, 3);
  R(ctx, "#d9e4ee", cx - 6, GROUND - 32, 68, 3);
  const f = 0.85 + Math.sin(now / 130) * 0.15;
  R(ctx, `rgba(245,158,11,${f})`, cx + 8, GROUND - 22, 10, 9); R(ctx, `rgba(245,158,11,${f})`, cx + 38, GROUND - 22, 10, 9);
  R(ctx, "rgba(245,158,11,0.12)", cx - 10, GROUND, 76, 8);
  R(ctx, "#c8d6e3", 0, GROUND, W, H - GROUND); R(ctx, "#8ea4bb", 0, GROUND, W, 1);
  const lead = -30 + Math.min(tt, 11.5) * 18;
  PEOPLE.forEach(([top, hair], i) => {
    const x = lead - i * 13;
    if (x > -10 && x < cx + 10) walker(ctx, x, top, hair, now, i);
    for (let k = 1; k < 6; k++) if (x - k * 9 > 0) R(ctx, "#9fb3c7", x - k * 9, GROUND + 3 + (k % 2), 2, 1);
  });
  for (let i = 0; i < 120; i++) R(ctx, "#e8f1ff", (i * 73.13 + now * 0.01) % W, (i * 41.7 + now * 0.025) % H, 1, 1);
  R(ctx, "#000", 0, 0, W, 16); R(ctx, "#000", 0, H - 16, W, 16);
  const fade = tt < 0.8 ? 1 - tt / 0.8 : tt > HOMEWARD_DURATION - 1 ? tt - (HOMEWARD_DURATION - 1) : 0;
  if (fade > 0) { ctx.fillStyle = `rgba(0,0,0,${Math.min(1, fade)})`; ctx.fillRect(0, 0, W, H); }
}
